export class ResettableTimeout {
    private callback: any;
    private ms: number;
    private timeoutRef: any = null;

    constructor(callback: any, ms: number) {
        this.callback = callback;
        this.ms = ms;
        this.timeoutRef = setTimeout(callback, ms);
    }

    public Reset() {
        this.Cancel();
        this.timeoutRef = setTimeout(this.callback, this.ms);
    }

    public Cancel() {
        if (this.timeoutRef) {
            clearTimeout(this.timeoutRef);
            this.timeoutRef = null;
        }
    }
};